import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    width: '100%',
  },
  listBox: {
    height: 'calc(100% - 198px)',
  },
  listRoot: {
    height: '100%',
    marginTop: 10,
    maxHeight: 300,
    overflow: 'auto',
  },
  avatarWrapper: {
    marginRight: -19,
  },
  avatar: {
    backgroundColor: '#00C1BA',
    height: 28,
    width: 28,
    fontSize: 13,
    marginTop: -theme.spacing(0.5),
    marginRigth: theme.spacing(1.2),
  },
  listItem: {
    backgroundColor: '#FBFBFB',
    margin: 0,
    marginBottom: theme.spacing(2),
  },
  name: {
    fontSize: 13,
    fontWeight: 'bold',
    lineHeight: 1.23,
    color: '#4D4F5C',
  },
  date: {
    fontSize: 12,
    color: '#777777',
  },
  comment: {
    color: '#4D4F5C',
    fontSize: 13,
    marginTop: theme.spacing(1),
    display: 'block',
    lineHeight: 1.18,
  },
  loadingContainer: {
    height: 150,
    width: '100%',
  },
  textarea: {
    backgroundColor: theme.palette.background.input,
    borderColor: theme.palette.form.borderDark,
    '& label': {
      color: `${theme.palette.form.placeholder} !important`,
      fontSize: `${theme.typography.pxToRem(13)} !important`,
    },
  },
}));

export default useStyles;
